import React, { Component } from 'react'
import {
  DivWithBackgroundColor,
  SecondaryDivBorder,
  StyledPanelButton,
} from './styled-components.js'
import '../../assets/stylesheets/accordion.scss'

class Accordion extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: -1,
      wasOpened: false,
    }
  }

  activateTab = index => {
    this.setState(prev => ({
      activeTab: prev.activeTab === index ? -1 : index,
      wasOpened: true,
    }))
  }

  render() {
    const {
      panels,
      primaryColor,
      secondaryColor,
      backgroundColor,
      marginBelow,
    } = this.props
    const { activeTab, wasOpened } = this.state
    return (
      <div id="accordion-component">
        <DivWithBackgroundColor
          backgroundColor={backgroundColor}
          className={`accordion margin-${marginBelow}`}
          role="tablist"
        >
          {panels.map((panel, index) => (
            <Panel
              primaryColor={primaryColor}
              secondaryColor={secondaryColor}
              backgroundColor={backgroundColor}
              key={index}
              activeTab={activeTab}
              wasOpened={wasOpened}
              index={index}
              {...panel}
              activateTab={this.activateTab.bind(null, index)}
            />
          ))}
        </DivWithBackgroundColor>
      </div>
    )
  }
}
export default Accordion

class Panel extends Component {
  render() {
    const {
      label,
      closeLabel,
      content,
      activeTab,
      wasOpened,
      index,
      activateTab,
      primaryColor,
      secondaryColor,
    } = this.props
    const isActive = activeTab === index
    const innerOpened = wasOpened ? 'innerWasOpened' : 'innerNeverOpened'

    return (
      <div className="panel" role="tabpanel" aria-expanded={isActive}>
        <div className="grid-row">
          <SecondaryDivBorder
            secondaryBorderTopColor={secondaryColor}
            className="section-column"
          >
            <StyledPanelButton
              primaryTextColor={primaryColor}
              xButtonPrimary={primaryColor}
              xButtonSecondary={secondaryColor}
              className="panel__label"
              role="tab"
              onClick={activateTab}
            >
              {isActive ? closeLabel : label}
            </StyledPanelButton>
          </SecondaryDivBorder>
        </div>
        <div className={`panel__inner ${innerOpened}`} aria-hidden={!isActive}>
          <div className="panel__content">{content}</div>
        </div>
        <div className="grid-row">
          <div className="col-12-12">
            <SecondaryDivBorder
              secondaryBorderTopColor={secondaryColor}
              className="section-column"
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared-page-components/accordion.js